import React from 'react'
import { observer } from 'mobx-react'
import moment from 'moment'

import Typography from '../../../UniformComponents/Typography'

const TitleSlide = observer(({ store }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ width: 120 }} />

        <Typography
            color="primary"
            type="b"
        >
            {`${store.presentation.clientName} - ${store.product.name}${store.product.edition.length ? ` - ${store.product.edition}` : ''}`}
        </Typography>

        <Typography color="white" type="h2">{store.appStore.survey.title}</Typography>

        <Typography color="white" type="b">{moment().format('MMMM YYYY')}</Typography>
    </div>
))

export default TitleSlide
